import React from 'react';
import { Item } from '@/components/landing/blocks/HeaderMenu/Item';
import { useTranslationWithLocale } from '@/hooks/useTranslationWithLocale';
import { type DropdownGroup } from '@/types';
import styles from './List.module.scss';

interface Props {
	data: DropdownGroup;
	toggleMenu?: () => void;
}
export const List: React.FC<Props> = ({ data, toggleMenu }) => {
	const { t } = useTranslationWithLocale('landing-header');
	// FIXME: change logic from grid to flex
	const half = Math.ceil(data.items.length / 2);

	return (
		<div key={data.title} className={styles['list']}>
			<h3 className={styles['list__title']}>{t(data.title)}</h3>
			<ul className={styles['list__items']}>
				{data.items.map((item, i) => (
					<li
						key={item.text}
						className={`${styles['list__item']} ${
							i < half
								? styles['list__item_first']
								: styles['list__item_second']
						}`}
					>
						<Item item={item} toggleMenu={toggleMenu} />
					</li>
				))}
			</ul>
		</div>
	);
};
